// Device ID management for device-operatory registration

const DEVICE_ID_KEY = 'dentalpulse_device_id';

/**
 * Generate a unique device ID using crypto API
 */
function generateDeviceId() {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * Get or create a persistent device ID
 * Stored in localStorage for persistence across sessions
 */
export function getDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    deviceId = generateDeviceId();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  
  return deviceId;
}

/**
 * Get a suggested device name based on browser/OS info
 */
export function getDeviceName() {
  const userAgent = navigator.userAgent;
  let deviceName = 'Unknown Device';
  
  // Try to extract useful info from user agent
  if (userAgent.includes('Windows')) {
    deviceName = 'Windows PC';
  } else if (userAgent.includes('Mac')) {
    deviceName = 'Mac';
  } else if (userAgent.includes('Linux')) {
    deviceName = 'Linux PC';
  } else if (userAgent.includes('iPad')) {
    deviceName = 'iPad';
  } else if (userAgent.includes('iPhone')) {
    deviceName = 'iPhone';
  } else if (userAgent.includes('Android')) {
    deviceName = 'Android Device';
  }
  
  // Add browser info
  if (userAgent.includes('Chrome')) {
    deviceName += ' (Chrome)';
  } else if (userAgent.includes('Firefox')) {
    deviceName += ' (Firefox)';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    deviceName += ' (Safari)';
  } else if (userAgent.includes('Edge')) {
    deviceName += ' (Edge)';
  }
  
  return deviceName;
}
